function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { getBlobFromURL } from './getBlobFromURL';
import { isDataUrl, toDataURL, getMimeType } from './util';
var URL_REGEX = /url\((['"]?)([^'"]+?)\1\)/g;
var URL_WITH_FORMAT_REGEX = /url\([^)]+\)\s*format\((["'])([^"']+)\1\)/g;
var FONT_SRC_REGEX = /src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;
export function shouldEmbed(string) {
  return string.search(URL_REGEX) !== -1;
}
export function embedResources(cssString, baseUrl, options) {
  if (!shouldEmbed(cssString)) {
    return Promise.resolve(cssString);
  }

  var filteredCssString = filterPreferredFontFormat(cssString, options);
  return Promise.resolve(filteredCssString).then(parseURLs).then(function (urls) {
    return urls.reduce(function (done, url) {
      return done.then(function (ret) {
        return embed(ret, url, baseUrl, options);
      });
    }, Promise.resolve(filteredCssString));
  });
}
export function filterPreferredFontFormat(str, _ref) {
  var preferredFontFormat = _ref.preferredFontFormat;
  return !preferredFontFormat ? str : str.replace(FONT_SRC_REGEX, function (match) {
    while (true) {
      var _ref2 = URL_WITH_FORMAT_REGEX.exec(match) || [],
          _ref3 = _slicedToArray(_ref2, 3),
          src = _ref3[0],
          format = _ref3[2];

      if (!format) {
        return '';
      }

      if (format === preferredFontFormat) {
        return "src: ".concat(src, ";");
      }
    }
  });
}
export function parseURLs(str) {
  var result = [];
  str.replace(URL_REGEX, function (raw, quotation, url) {
    result.push(url);
    return raw;
  });
  return result.filter(function (url) {
    return !isDataUrl(url);
  });
}
export function embed(cssString, resourceURL, baseURL, options, get) {
  var resolvedURL = baseURL ? resolveUrl(resourceURL, baseURL) : resourceURL;
  return Promise.resolve(resolvedURL).then(function (url) {
    return get ? get(url) : getBlobFromURL(url, options);
  }).then(function (data) {
    if (typeof data === 'string') {
      return toDataURL(data, getMimeType(resourceURL));
    }

    return toDataURL(data.blob, getMimeType(resourceURL) || data.contentType);
  }).then(function (dataURL) {
    return cssString.replace(urlToRegex(resourceURL), "$1".concat(dataURL, "$3"));
  }).then(function (content) {
    return content;
  }, function () {
    return resolvedURL;
  });
}

function resolveUrl(url, baseUrl) {
  // url is absolute already
  if (url.match(/^[a-z]+:\/\//i)) {
    return url;
  } // url is absolute already, without protocol


  if (url.match(/^\/\//)) {
    return window.location.protocol + url;
  } // dataURI, mailto:, tel:, etc.


  if (url.match(/^[a-z]+:/i)) {
    return url;
  }

  var doc = document.implementation.createHTMLDocument();
  var base = doc.createElement('base');
  var a = doc.createElement('a');
  doc.head.appendChild(base);
  doc.body.appendChild(a);

  if (baseUrl) {
    base.href = baseUrl;
  }

  a.href = url;
  return a.href;
}

function urlToRegex(url) {
  return new RegExp("(url\\(['\"]?)(".concat(escape(url), ")(['\"]?\\))"), 'g');
}

function escape(url) {
  return url.replace(/([.*+?^${}()|\[\]\/\\])/g, '\\$1');
}